export const ITEMS_PER_PAGE = 12;
